<svg id="Previous" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
    <circle id="Ellipse_20" data-name="Ellipse 20" cx="25" cy="25" r="25" fill="rgba(0,132,200,0.1)"/>
    <g id="round-arrow_forward-24px" transform="translate(36.582 36.593) rotate(180)">
        <path id="Path_14" data-name="Path 14" d="M5,13H16.17l-4.88,4.88a1.008,1.008,0,0,0,0,1.42,1,1,0,0,0,1.41,0l6.59-6.59a1,1,0,0,0,0-1.41L12.71,4.7A1,1,0,1,0,11.3,6.11L16.17,11H5a1,1,0,0,0,0,2Z" fill="#0084c8"/>
    </g>
</svg>
